export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST";
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS";
export const FETCH_LOGIN_FAILURE = "FETCH_LOGIN_FAILURE";
export const FETCH_SIGNUP_REQUEST = "FETCH_SIGNUP_REQUEST";
export const FETCH_SIGNUP_SUCCESS = "FETCH_SIGNUP_SUCCESS";
export const FETCH_SIGNUP_FAILURE = "FETCH_SIGNUP_FAILURE";
export const FETCH_EDIT_REQUEST = "FETCH_EDIT_REQUEST";
export const FETCH_EDIT_SUCCESS = "FETCH_EDIT_SUCCESS";
export const FETCH_EDIT_FAILURE = "FETCH_EDIT_FAILURE";
export const FETCH_LOGOUT_REQUEST = "FETCH_LOGOUT_REQUEST";
export const FETCH_LOGOUT_SUCCESS = "FETCH_LOGOUT_SUCCESS";
export const FETCH_LOGOUT_FAILURE = "FETCH_LOGOUT_FAILURE";

